import React from 'react';

const IconR = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid"
    width="256"
    height="198"
    viewBox="0 0 256 197.411"
  >
    <defs>
      <linearGradient
        id="A"
        x1="0"
        x2="256"
        y1="-105.397"
        y2="276.848"
        gradientUnits="userSpaceOnUse"
        spreadMethod="pad"
      >
        <stop offset="0" stopColor="#cbced0" />
        <stop offset="1" stopColor="#84838b" />
      </linearGradient>
      <linearGradient
        id="B"
        x1="105.473"
        x2="246.77"
        y1="53.23"
        y2="197.411"
        gradientUnits="userSpaceOnUse"
        spreadMethod="pad"
      >
        <stop offset="0" stopColor="#276dc3" />
        <stop offset="1" stopColor="#165caa" />
      </linearGradient>
    </defs>
    <g fillRule="evenodd">
      <path
        d="M128 171.45c-70.692 0-128-38.38-128-85.725S57.308 0 128 0s128 38.38 128 85.725-57.307 85.725-128 85.725zm19.593-137.935c-53.732 0-97.29 26.24-97.29 58.605s43.56 58.605 97.29 58.605 93.386-17.94 93.386-58.605c0-40.654-39.654-58.605-93.386-58.605z"
        fill="url(#A)"
      />
      <path
        d="M194.937 132.776s7.747 2.338 12.248 4.615c1.562.8 4.264 2.367 6.213 4.438 1.91 2.028 2.84 4.083 2.84 4.083l30.53 51.477-49.347.022-23.076-43.334s-4.725-8.12-7.633-10.473c-2.425-1.964-3.46-2.663-5.858-2.663H149.13l.01 56.438-43.667.02V53.23h87.69s39.94.72 39.94 38.72-38.164 40.827-38.164 40.827zm-18.993-48.274l-26.436-.017-.013 24.514h26.45s12.248-.038 12.248-12.47c0-12.682-12.248-12.018-12.248-12.018z"
        fill="url(#B)"
      />
    </g>
  </svg>
);
export default IconR;
